import React, { useEffect, useState, useContext } from "react";
import * as services from "../../../store/service";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { stateList } from "../../../util/CommonLists";
import BusinessCreditProfileSubmitted from "./BusinessCreditProfileSubmitted";
import * as LoginActions from "../../../store/loginService/actions";
import { useDispatch } from "react-redux";
import { CommonContext } from "../../../CommonContextProvider";
import { useLocation } from "react-router-dom";

export interface IProps {
    backToMainForm: any;
    BusinessName?: string;
    Street?: string;
    City?: string;
    State?: string;
    PostalCode?: string;
    Phone?: string;
    Email?: string;
    FirstName?: string;
    LastName?: string;
    Website?: string;
    CharterfileNumber?: string;
    EIN?: string;
    CreditProvider?: string;
    location?: any;
    DUNSNumber?: string;
}

const BusinessCreditProfileReview: React.FunctionComponent<IProps> = (props) => {
    const dispatch = useDispatch();
    const location = useLocation();

    const { updateBusinessProfileDshboardGetStartedStatus }: any = useContext(CommonContext);
    const updateSmbServiceDetails = () => dispatch(LoginActions.actionCreators.updateSmbServiceDetails());

    const [selectedTab, setSelectedTab] = useState("0");
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const { handleSubmit } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const unmaskPhoneNumber = (phoneNumber?: string) => {
        let phoneNumberWithoutMasking = phoneNumber;
        if (
            phoneNumberWithoutMasking &&
            phoneNumberWithoutMasking.includes("-") &&
            phoneNumberWithoutMasking.includes(")") &&
            phoneNumberWithoutMasking.includes("(") &&
            phoneNumberWithoutMasking.includes(" ")
        ) {
            phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace(" ", "");
            phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace("(", "");
            phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace(")", "");
            phoneNumberWithoutMasking = phoneNumberWithoutMasking.replace("-", "");
        }

        return phoneNumberWithoutMasking;
    };

    const submitCreditProfileForm = (data: any) => {
        setIsLoading(true);

        let requestBody = {
            BusinessName: props.BusinessName,
            Street: props.Street,
            City: props.City,
            State: props.State,
            PostalCode: props.PostalCode,
            Phone: unmaskPhoneNumber(props.Phone),
            Email: props.Email,
            BusinessWebsite: props.Website,
            CharterOrFileNumber: props.CharterfileNumber,
            DUNSNumber: props.DUNSNumber,
            CompanyEIN: props.EIN,
            FirstName: props.FirstName,
            LastName: props.LastName,
            CreditProvider: props.CreditProvider,
        };

        services.createBusinessCreditProfileCase(requestBody).then((data: any) => {
            setIsLoading(false);
            updateBusinessProfileDshboardGetStartedStatus();

            if (data.SFCaseId) {
                updateSmbServiceDetails();
                setIsSubmitted(true);
            } else {
                if (data.Errors && data.Errors.length > 0) {
                    Notification({
                        type: "error",
                        title: "Business Credit Profile",
                        message: data.errors[0],
                        duration: 5,
                    });
                } else {
                    Notification({
                        type: "error",
                        title: "Business Credit Profile",
                        message: "Could not save information.Please try again later.",
                        duration: 5,
                    });
                }
            }
        });
    };

    const ensureDataFetched = () => {
        const query = new URLSearchParams(location.search);
        const tmpselectedTab = query.get("selectedTab");
        if (tmpselectedTab != null) {
            setSelectedTab(tmpselectedTab);
        }
    };

    useEffect(ensureDataFetched, []);

    return (
        <React.Fragment>
            {!isSubmitted ? (
                <div className="box offset-padding">
                    <div className="box-header">
                        <div className="box-title-container">
                            <div className="box-title-icon" aria-hidden="true">
                                <em className="lar la-file-alt"></em>
                            </div>
                            <div className="box-title-text has-actions">
                                <h2 className="box-title">Add My Business Name and Address</h2>
                            </div>
                        </div>
                        <div className="box-description">
                            <p>Please review the data below for accuracy.</p>
                        </div>
                    </div>
                    <div className={`box-content ${isLoading && "loading"}`}>
                        <form id="form-review-business-credit-profile" onSubmit={handleSubmit(submitCreditProfileForm)}>
                            <div role="grid" className="data-grid " id="business-credit-profile-grid" aria-hidden="false">
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-name-label">
                                            Business Name
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-name-label">
                                            {props.BusinessName}
                                        </div>
                                    </div>
                                </div>

                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-address-street-label">
                                            Business Address Street
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-address-street-label">
                                            {props.Street}
                                        </div>
                                    </div>
                                </div>

                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-address-city-label">
                                            Business Address City
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-address-city-label">
                                            {props.City}
                                        </div>
                                    </div>
                                </div>

                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-address-state-label">
                                            State
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-address-state-label">
                                            {stateList.find((it: any) => it.value === props.State)?.name}
                                        </div>
                                    </div>
                                </div>

                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-address-zip-code">
                                            Zip Code
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-address-zip-code">
                                            {props.PostalCode}
                                        </div>
                                    </div>
                                </div>

                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-business-phone-number">
                                            Business Phone Number
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="label-business-phone-number">
                                            {props.Phone}
                                        </div>
                                    </div>
                                </div>

                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-email-address-label">
                                            Email Address
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-email-address-label">
                                            {props.Email}
                                        </div>
                                    </div>
                                </div>

                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="business-website-label">
                                            Business Website
                                        </div>
                                    </div>
                                    <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                        <div className="data-value" aria-labelledby="business-website-label">
                                            {props.Website}
                                        </div>
                                    </div>
                                </div>

                                {props.CreditProvider != null && props.CreditProvider === "CREDITSAFE" && (
                                    <div role="row" className="data-row row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="business-charterfile-number-label">
                                                Charterfile Number
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="business-charterfile-number-label">
                                                {props.CharterfileNumber}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {props.CreditProvider != null && props.CreditProvider === "CREDITSAFE" && (
                                    <div role="row" className="data-row row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="business-ein-label">
                                                Company EIN
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="business-ein-label">
                                                {props.EIN}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {props.CreditProvider != null && props.CreditProvider === "DUNBRADSTREET" && (
                                    <div role="row" className="data-row row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id="business-duns-number-label">
                                                D-U-N-S Number
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter">
                                            <div className="data-value" aria-labelledby="business-duns-number-label">
                                                {props.DUNSNumber}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="margin-top-xl"></div>

                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-primary-outline" onClick={props.backToMainForm(true)}>
                                        <span className="btn-text">Back</span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary btn-min-width">
                                        <span className="btn-text">Submit</span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            ) : (
                <BusinessCreditProfileSubmitted selectedTab={selectedTab} creditProvider={props.CreditProvider} />
            )}
        </React.Fragment>
    );
};

export default BusinessCreditProfileReview;
